module.exports = __webpack_public_path__ + "static/skybell-and-app-48b8f23d1ac69d86a2d318fda5c71b06.jpg";